export default "__VITE_ASSET__VbcHZf96__"